<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      :left-arrow="true"
      :z-index="10"
      :title="getNavTitle"
      @click-left="goableBack()"></van-nav-bar>
    <div class="contain">
      <div class="title-bg">身份信息</div>
      <van-cell-group class="group">
        <van-field
          class="username"
          v-model="name"
          type="default"
          placeholder="请输入姓名"
          border
          clearable />
        <van-field
          v-model="idNumber"
          type="default"
          maxlength="18"
          placeholder="请输入身份证号码"
          border
          clearable />
      </van-cell-group>
      <van-button
        class="btn"
        color="rgb(206, 29, 35)"
        round
        type="warning"
        @click="onNextAction"
        v-preventReClick="500"
        >下一步</van-button
      >
    </div>
  </div>
</template>
    
    <script>
import * as CustApi from "@/api/cust"

import { CellGroup, Field, Toast } from "vant"
import session from "../../utils/session"
import * as validate from "../../utils/validate"

export default {
  name: "settingPwd",
  components: {
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Toast.name]: Toast
  },
  data() {
    return {
      cacheParams: {
        type: 1, // 1 忘记密码 2 注册 3 登录后未设置密码 4 个人中心进入设置密码
        mobile: "",
        referrerCode: ""
      },
      name: "",
      idNumber: ""
    }
  },
  computed: {
    getNavTitle() {
      if (this.cacheParams.type == 1) {
        return "忘记密码"
      } else if (this.cacheParams.type == 2) {
        return "注册"
      } else if (this.cacheParams.type == 3) {
        return "设置密码"
      } else if (this.cacheParams.type == 4) {
        return "设置密码"
      } else {
        return ""
      }
    }
  },
  beforeMount() {
    this.cacheParams = session.getJson("RegisterAndForgetPwdKey")
  },
  beforeDestroy() {},
  methods: {
    onNextAction() {
      if (!validate.realName(this.name)) {
        this.$toast("输入姓名格式不正确")
        return
      }
      if (!validate.idNum(this.idNumber)) {
        this.$toast("请输入正确身份信息")
        return
      }
      let params = {
        mobile: this.cacheParams.mobile,
        loginType: "ALTTC",
        name: this.name,
        idNumber: this.idNumber,
        referrerCode: this.cacheParams.referrerCode,
        referrerType: localStorage.getItem("MallEnterKey") || ""
      }
      this.onLogin(params)
    },
    onLogin(params) {
      CustApi.login(params)
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }
          localStorage.removeItem("MallEnterKey")
          session.setJson("RegisterAndForgetPwdKey", this.cacheParams)
          this.$router.push({
            name: "personalCenter-loginpwd4"
          })
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    }
  }
}
</script>
    
    <style lang="less" scoped>
.page-container {
  min-height: calc(100vh - 45px);
  background-color: white;
  overflow: hidden;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0px 0;
}
.title-bg {
  margin: 50px 20px;
  font-size: 20px;
  font-weight: 500;
}
.group {
  margin: 50px 40px;
  .username {
    margin-bottom: 30px;
  }
  .van-field {
    border: 1px solid rgb(208, 211, 213);
    border-radius: 5px;
    font-size: 15px;
  }
}
.btn {
  margin: 0 40px;
  height: 44px;
  width: calc(100vw - 80px);
  border-radius: 22px;
  font-size: 15px;
  font-weight: 500;
}
</style>
    